import React, { useState, useEffect } from 'react';
import styles from './asset/loadingSpinner.module.scss';
import MessageConstant from '../../utils/Constant/MessageConstant';

const LoadingSpinner = ({
    message = MessageConstant.LOADING,
    timeout = 30000, // 30 seconds default timeout
    onTimeout = null
}) => {
    const [isTimeout, setIsTimeout] = useState(false);

    useEffect(() => {
        if (timeout <= 0) return; // No timeout if set to 0 or negative

        const timer = setTimeout(() => {
            setIsTimeout(true);
            if (onTimeout) {
                onTimeout();
            }
        }, timeout);

        return () => clearTimeout(timer);
    }, [timeout, onTimeout]);

    if (isTimeout) {
        return (
            <div className={styles.loadingContainer}>
                <div className={styles.loadingContent}>
                    <div className={styles.timeoutMessage}>
                        <h3>Request Timeout</h3>
                        <p>The request is taking longer than expected.</p>
                        <p>Please check your connection and try again.</p>
                        <button
                            className={styles.reloadButton}
                            onClick={() => window.location.reload()}
                        >
                            Reload Page
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.loadingContainer}>
            <div className={styles.loadingContent}>
                <div className={styles.spinnerContainer}>
                    <div className={styles.spinner}></div>
                </div>
                <p className={styles.loadingMessage}>{message}</p>
            </div>
        </div>
    );
};

export default LoadingSpinner;